import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AppEntry, AppStatus } from '../app-selector.component';

interface StatusConfig {
  icon: string;
  label: string;
  cssClass: string;
}

@Component({
  selector: 'sw-app-card',
  templateUrl: './app-card.component.html',
  styleUrls: ['./app-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppCardComponent {
  /** Referencia al enum expuesta para que el template pueda comparar valores. */
  readonly AppStatus = AppStatus;

  @Input({ required: true }) app!: AppEntry;

  @Output() appSelected = new EventEmitter<AppEntry>();

  get statusConfig(): StatusConfig {
    switch (this.app.status) {
      case AppStatus.Running:
        return { icon: 'pi-circle-fill', label: 'APP.STATUS.RUNNING', cssClass: 'status-running' };
      case AppStatus.Offline:
        return { icon: 'pi-circle', label: 'APP.STATUS.OFFLINE', cssClass: 'status-offline' };
      case AppStatus.Maintenance:
        return { icon: 'pi-wrench', label: 'APP.STATUS.MAINTENANCE', cssClass: 'status-maintenance' };
      case AppStatus.Disabled:
        return { icon: 'pi-ban', label: 'APP.STATUS.DISABLED', cssClass: 'status-disabled' };
      default:
        return { icon: 'pi-circle-fill', label: 'APP.STATUS.RUNNING', cssClass: 'status-running' };
    }
  }

  onSelect(): void {
    this.appSelected.emit(this.app);
  }
}
